import { SxProps } from "@mui/system";
import { CustomMessageContent, ThemeV2 } from "../../../util/types";

export const textContent = (
  theme: ThemeV2,
  msg: CustomMessageContent,
): SxProps => {
  let color: string | null = null;
  if (msg?.error_message) {
    color = theme.tokens.color.feedback.error;
  } else if (msg?.self) {
    color = theme.tokens.color.action.primaryText;
  }

  return {
    color,
    whiteSpace: "pre-line",
    width: "100%",
    lineHeight: theme.tokens.typography.lineHeight.normal,
    "& *:not(:last-child)": {
      marginBottom: `${theme.tokens.spacing["1"]}px`,
    },
    marginBottom: 0,
  };
};

export const imageStyle = (theme: ThemeV2): SxProps => ({
  borderRadius: `${theme.tokens.shape.radius.lg}px`,
  width: "auto",
  height: "auto",
  maxWidth: "100%",
  maxHeight: { md: "600px", xs: "400px" },
  margin: "auto",
});
